import benifits from "../../Configs/JSON/benifits.json"
import "../../styles/Benefits/IncomePlan.less"

import TextMultiStyle from "../Common/TextMultiStyle"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store/index"

import GenericComponenetHeader from "../Common/GenericComponenetHeader"
import Image from "../Common/Image"

const IncomePlan = observer(({ personaType = "Wealth" }) => {
  return (
    <div className="IncomePlan_FlexBox">
      <div className="IncomePlan_Parent1">
        <Image
          width={AppStore.device === 1 ? "156px" : "139px"}
          height={AppStore.device === 1 ? "141px" : "124px"}
          src={AppStore.device === 1 ? `assets/common/${personaType}/Banner2.png` : `assets/common/${personaType}/Banner2Mobile.png`}
          className={"IncomePlan_ListImage"}
          alt={"Wealth Creation"}
        />
      </div>
      <div className="IncomePlan_Parent2">
        <div className="IncomePlan_Card">
          <h1 className="IncomePlan_CardText">{benifits["Background"][personaType]["Title"]}</h1>
        </div>
        {/* <div className="IncomePlan_BigText"> */}
        <TextMultiStyle StyleText="IncomePlan_BigText" text={benifits["Background"][personaType]["subTitle"]} />
        {/* </div> */}

        {/* below component to be added on top of benefits grid */}
        {AppStore.device === 0 && (
          <GenericComponenetHeader
            content={benifits.BHTTitleText}
            onClick={() => {
              // DataLayerFn("OnlineBenefits_Selected||Calculator-Landing page|Online Benefits", FormStore, "", "Buy online & get up to 2% Additional Benefit~", "", "")
              // BenefitStore.setAddBenefitModal(true)
              // DataLayerFn("OnlineBenefits_PopupOpen||Calculator-Landing page|Online Benefits", FormStore, "", "Buy online & get up to 2% Additional Benefit~", "", "")
            }}
          />
        )}

        {/* <CheckList data={benifits["IncomePlan"]} imgSrc={AppStore.device === 0 ? CheckMob_Black : CheckPc_White} textClassName={"IncomePlan_ListText"}  imgwidth1={"19px"} imgheight1={"13px"} imgwidth0={"14px"} imgheight0={"11px"} imgalt={"Tick"} /> */}
      </div>
    </div>
  )
})

export default IncomePlan
